var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssignmentsDarkblue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 18.1172L4.93925 21.6082C5.55542 22.1218 6.33211 22.4029 7.13417 22.4029H18.1786C18.9675 22.4029 19.6071 21.7633 19.6071 20.9744C19.6071 19.3964 18.3279 18.1172 16.75 18.1172H9.07164M5.89286 16.4029L7.17857 17.6886C7.88865 18.3987 9.03993 18.3987 9.75 17.6886C10.4601 16.9786 10.4601 15.8273 9.75 15.1172L7.75421 13.1214C7.11122 12.4784 6.23916 12.1172 5.32983 12.1172H0.75M18.5298 1.75H19.8798C20.1185 1.75 20.3475 1.85536 20.5162 2.0429C20.685 2.23043 20.7798 2.48479 20.7798 2.75V12.75C20.7798 13.0152 20.685 13.2696 20.5162 13.4571C20.3475 13.6446 20.1185 13.75 19.8798 13.75H12.6798C12.4412 13.75 12.2122 13.6446 12.0435 13.4571C11.8747 13.2696 11.7798 13.0152 11.7798 12.75V2.75C11.7798 2.48479 11.8747 2.23043 12.0435 2.0429C12.2122 1.85536 12.4412 1.75 12.6798 1.75H14.0298M14.0298 1.75L14.0298 2.25C14.0298 2.80228 14.4328 3.25 14.9298 3.25H17.6298C18.1269 3.25 18.5298 2.80228 18.5298 2.25L18.5298 1.75C18.5298 1.19772 18.1269 0.75 17.6298 0.75H14.9298C14.4328 0.75 14.0298 1.19772 14.0298 1.75ZM14.0298 5.75H18.5298M14.0298 8.24998H18.5298M14.0298 10.75H18.5298",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignmentsDarkblue);
export default __webpack_public_path__ + "static/media/assignments-darkblue.60d2befa.svg";
export { ForwardRef as ReactComponent };